import { Typography } from "components/atoms";
import { Modal } from "../Modal";
import { CloseIcon } from "components/atoms/Icon";
import "./index.scss";

interface Material {
  Name: string;
  Pin: string;
  Order: number;
}

interface IProps {
  handleOnClose: () => void;
  isOpen: boolean;
  theme?: "light" | "dark";
  materials?: Material[];
}

export const GMATMaterialModal = ({ handleOnClose, isOpen, theme, materials = [] }: IProps) => {
  // Sort materials by Order property
  const sortedMaterials = materials && Array.isArray(materials) && materials.length > 0
    ? [...materials].sort((a, b) => a.Order - b.Order)
    : [];
  return (
    <Modal isOpen={isOpen} onClose={handleOnClose} theme={theme}>
      <div className="gmat-material-modal-wrapper">
        <div className="gmat-material-modal-header">
          <div className="gmat-material-modal-header-typography">
            <div className="title-typography-wrapper">
              <Typography
                label="Official GMAC Material"
                variant="h4Med"
                styles="gmat-material-modal-header-typography-custom-style"
              />
            </div>
          </div>
          <div
            className="gmat-material-modal-header-close-icon"
            onClick={handleOnClose}
          >
            <CloseIcon theme={theme} />
          </div>
        </div>
        <div className="gmat-material-modal-body">
          <Typography
            label="VITALSOURCE BOOKSHELF (EBOOK ACCESS)"
            variant="h4Med"
            styles="gmat-material-text-style custom-typo-styles-modal-topic"
          />
          <Typography
            label="VitalSource Bookshelf is the world’s leading platform for distributing, accessing, consuming, and engaging with digital textbooks and course materials."
            variant="h8Book"
            styles="gmat-material-text-style custom-typo-styles"
          />
          <Typography
            label="To access for the first time:"
            variant="h8Book"
            styles="gmat-material-text-style custom-typo-styles"
          />
          <Typography
            label={
              <>
                1. Visit{" "}
                <a
                  className="gmat-material-text-link"
                  href="https://bookshelf.vitalsource.com/#/user/signin"
                  target="__blank"
                >
                  VitalSource Bookshelf Online
                </a>
              </>
            }
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="2. Click Create a VitalSource Account"
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="3. Enter an email and password to create your account."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="4. Log into your account."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="5. Click Redeem Codes, which is located at the bottom right of the page."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="6. Enter your code for the Official Guide ebook and any other ebooks that came with your course. All your codes are at the bottom of this message."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="7. If you get an error when trying to redeem a code, please check that you used the code for the ebook rather than the code for the question bank."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="8. (Optional) Download the desktop app by clicking the apps button in the upper right corner of the screen."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="9. (Optional) You can also download a mobile app by searching for VitalSource Bookshelf in the app store for your mobile device. There are mobile versions available for both Apple and Android devices."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="10. If you plan to access your ebooks using the VitalSource Bookshelf website, bookmark the website."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="Question Bank Access"
            variant="h4Med"
            styles="gmat-material-text-style custom-typo-styles-modal-topic custom-typo-styles-modal-topic-question-bank"
          />
          <Typography
            label="To access for the first time:"
            variant="h8Book"
            styles="gmat-material-text-style custom-typo-styles"
          />
          <Typography
            label={
              <>
                1. Visit{" "}
                <a
                  className="gmat-material-text-link"
                  href="http://MBA.com"
                  target="__blank"
                >
                  http://MBA.com
                </a>
              </>
            }
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label={
              <>
                2. Log into your{" "}
                <a
                  className="gmat-material-text-link"
                  href="http://MBA.com"
                  target="__blank"
                >
                  http://MBA.com
                </a>{" "}
                account.
              </>
            }
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="3. Click Access GMAT Focus Official Starter Kit (Free)."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="4. Click the Redeem Activation Codes button."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="5. Enter your activation code."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="6. Click confirm."
            variant="h8Book"
            styles="custom-typo-styles"
          />
          <Typography
            label="7. Click Study for the Drill Bank item."
            variant="h8Book"
            styles="custom-typo-styles"
          />

          <div className="gmac-key-values-container">
            {sortedMaterials.length > 0 ? (
              sortedMaterials.map((material, index) => (
                <div key={index} className="gmac-key-value-wrapper">
                  <Typography
                    variant="h4Med"
                    label={`Your ${material.Name} PIN: `}
                    styles="gmac-key-custom-style"
                  />
                  <Typography
                    label={material.Pin}
                    variant="h6Book"
                    styles="gmac-value-custom-style"
                  />
                </div>
              ))
            ) : (
              <Typography
                label="We're sorry, your GMAC material could not be retrieved at this time. Please contact Customer Support if you continue to receive this message."
                variant="h8Book"
                styles="custom-typo-styles"
              />
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};
